import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  emoji: '🥐',
  name: 'Desayunos'
}, {
  emoji: '🥩',
  name: 'Milanesas'
}, {
  emoji: '🫓',
  name: 'Empanadas'
}, {
  emoji: '🥔',
  name: 'Papas'
}, {
  emoji: '🍗',
  name: 'Pollo'
}, {
  emoji: '🍰',
  name: 'Postres'
}, {
  emoji: '🥬',
  name: 'Vegano'
}, {
  emoji: '🐟',
  name: 'Pescado'
}, {
  emoji: '🦐',
  name: 'Mariscos'
}, {
  emoji: '⚡',
  name: 'Express'
}];
export function CategoriesSection() {
  return <section className="w-full py-12 md:py-20 px-6 bg-surface overflow-hidden" data-id="element-38">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-39">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-serif mb-10 text-charcoal" data-id="element-40">
          ¿Qué vas a poder cocinar?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-41">
          {categories.map((cat, index) => <div key={index} className="flex items-center gap-2 bg-background border border-primary/10 rounded-full px-5 py-2.5 shadow-sm hover:border-primary/30 transition-colors cursor-default" data-id="element-42">
              <span className="text-xl" data-id="element-43">{cat.emoji}</span>
              <span className="font-medium text-charcoal" data-id="element-44">{cat.name}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-12" data-id="element-45">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-46">
            Quiero cocinar todo esto →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}